import { Form, Modal } from "antd";
import { useState } from "react";
import styles from "../../clientsJob.module.scss";
import AddJobCandidate from "../../../../candidates/addJobCandidate";

export const AddCandidateModal = ({
  open,
  onCancel,
  onFinish,
  loading,
  getCandidateUdf,
}) => {
  const [form] = Form.useForm();

  const [isDataLoading, setIsDataLoading] = useState(true);

  return (
    <Modal
      title="Add New Candidate"
      className={`${styles.addNewCandidateModal} s2-theme-style modal-overflow-auto`}
      open={open}
      width={632}
      centered
      destroyOnClose
      onCancel={onCancel}
      closeIcon={<i className={`icon-closeable ${styles.closeAble}`} />}
      okText="Submit"
      onOk={form.submit}
      okButtonProps={{ loading, disabled: isDataLoading }}
    >
      <AddJobCandidate
        styles={styles}
        form={form}
        getCandidateUdf={getCandidateUdf}
        onFinish={onFinish}
        isDataLoading={isDataLoading}
        setIsDataLoading={setIsDataLoading}
      />
    </Modal>
  );
};
